export const darkenColor = (colorCode: string, ratio: number) => {
  if (colorCode === '#fff') return colorCode
  // カラーコードをRGB値に変換
  const hex = colorCode ? colorCode.replace(/^#/, '') : ''
  const bigint = parseInt(hex, 16)
  const red = (bigint >> 16) & 255
  const green = (bigint >> 8) & 255
  const blue = bigint & 255

  // 色を濃くする処理
  const darkerRed = Math.floor(red * (1 - ratio))
  const darkerGreen = Math.floor(green * (1 - ratio))
  const darkerBlue = Math.floor(blue * (1 - ratio))

  // 新しい色を16進数に変換
  const darkerHex = ((darkerRed << 16) + (darkerGreen << 8) + darkerBlue).toString(16)

  // 16進数をカラーコード形式に整形
  return `#${darkerHex.padStart(6, '0')}`
}

// export const darkenColor2 = (hex: string, percentage: number = 20): string => {
//   // HEXコードをRGBに変換
//   const rgb = hex.match(/[\da-f]{2}/gi)?.map((h) => parseInt(h, 16))
//   if (!rgb || rgb.length !== 3) {
//     throw new Error('Invalid hex color')
//   }

//   // RGB値を一定割合暗くする
//   const factor = 1 - percentage / 100
//   const darkenedRgb = rgb.map((value) => Math.max(0, Math.round(value * factor)))

//   // RGBをHEXに変換して返す
//   return `#${darkenedRgb.map((val) => val.toString(16).padStart(2, '0')).join('')}`
// }

// console.log(darkenColor('#e37d00')) // 20% 暗くした色
